import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import heroM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.24 AM.jpeg';
import technologyM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.42 AM.jpeg';
import showroomM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.01.02 AM.jpeg';
import interiorDashM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM (1).jpeg';
import interiorClusterM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM.jpeg';
import interiorCabinM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM (1).jpeg';
import interiorSeatM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM (2).jpeg';
import interiorPanoramicM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM.jpeg';
import interiorRoofM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM (2).jpeg';
import PageSeo, {
  articleJsonLd,
  breadcrumbJsonLd,
  keywordSets,
  localBusinessJsonLd,
} from '../PageSeo';

const waLink =
  'https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20ingin%20update%20harga%20BYD%20M6%20DM%20coming%20soon%20di%20BYD%20BSD%20Serpong%20dan%20info%20pre-book';

const specCards = [
  { value: 'Coming Soon', label: 'Harga BYD M6 DM' },
  { value: '10.1s', label: '0 - 100 km/h' },
  { value: '18 kWh + 52 L', label: 'Baterai dan tangki bensin' },
  { value: '1200 km', label: 'Range NEDC' },
];

const buyingPoints = [
  {
    title: 'Masuk waiting list lebih awal',
    text: 'Karena harga masih coming soon, langkah paling aman adalah meninggalkan kontak agar update harga, estimasi unit, dan opsi pre-book bisa langsung diinformasikan saat tersedia.',
  },
  {
    title: 'Bandingkan dengan BYD M6 EV',
    text: 'M6 DM cocok untuk pembeli yang ingin kabin MPV keluarga, tetapi masih butuh fleksibilitas bensin untuk perjalanan luar kota atau rute yang belum nyaman dengan charging.',
  },
  {
    title: 'Cek kebutuhan harian dan jarak jauh',
    text: 'Kalau pemakaian harian banyak di area BSD, Tangerang, dan Jakarta, karakter listrik terasa relevan. Saat perjalanan panjang, sistem DM membantu menjaga range tetap panjang.',
  },
];

const areaCards = [
  'BSD Serpong',
  'Tangerang Selatan',
  'Gading Serpong',
  'Alam Sutera',
  'Jakarta Barat',
  'Jakarta Selatan',
];

const interiorCards = [
  {
    image: interiorDashM6Dm,
    title: 'Speedometer digital',
    text: 'Panel speedometer digital menampilkan status HEV, konsumsi energi, tekanan ban, dan data perjalanan.',
  },
  {
    image: interiorClusterM6Dm,
    title: 'Kursi penumpang',
    text: 'Kursi penumpang terlihat lega dengan armrest dan posisi duduk yang nyaman untuk keluarga.',
  },
  {
    image: interiorCabinM6Dm,
    title: 'Kursi depan, tengah, dan row 3',
    text: 'Sudut foto ini memperlihatkan susunan kabin dari kursi depan, baris tengah, sampai row 3.',
  },
  {
    image: interiorSeatM6Dm,
    title: 'Kursi depan',
    text: 'Tampilan kursi depan memperlihatkan posisi duduk pengemudi dan penumpang depan dengan konsol tengah yang praktis.',
  },
  {
    image: interiorPanoramicM6Dm,
    title: 'Dashboard dan setir',
    text: 'Bagian dashboard dan setir memperlihatkan layar tengah, panel instrumen, dan layout kontrol pengemudi.',
  },
  {
    image: interiorRoofM6Dm,
    title: 'Fokus setir',
    text: 'Foto ini menonjolkan setir multifungsi BYD M6 DM dan tombol kontrol yang mudah dijangkau.',
  },
];

const faqItems = [
  {
    question: 'Berapa harga BYD M6 DM di BSD Serpong?',
    answer:
      'Harga BYD M6 DM masih coming soon. Hubungi Junius di BYD BSD Serpong untuk update harga resmi, estimasi ketersediaan unit, dan info pre-book.',
  },
  {
    question: 'Apakah BYD M6 DM bisa diisi bensin?',
    answer:
      'Bisa. BYD M6 DM menggunakan teknologi Dual Mode plug-in hybrid, sehingga mobil dapat memakai tenaga listrik dan tetap memiliki tangki bensin untuk perjalanan jauh.',
  },
  {
    question: 'Apa perbedaan BYD M6 DM dengan BYD M6 listrik?',
    answer:
      'BYD M6 listrik berfokus pada EV murni, sedangkan M6 DM menggabungkan motor listrik, baterai, dan mesin bensin. M6 DM lebih fleksibel untuk pembeli yang sering menempuh rute jauh.',
  },
  {
    question: 'Apakah bisa pre-book BYD M6 DM?',
    answer:
      'Untuk info pre-book, waiting list, dan jadwal test drive saat unit tersedia, Anda bisa langsung menghubungi Junius di BYD BSD Serpong.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

function HargaM6DMDetail() {
  return (
    <>
      <PageSeo
        title='Harga BYD M6 DM BSD Serpong | Coming Soon & Pre-Book 2026'
        description='Harga BYD M6 DM BSD Serpong masih coming soon. Cek info pre-book, waiting list, spesifikasi 10.1s, baterai 18 kWh, tangki 52 L, range 1200 km NEDC, dan konsultasi dengan Junius.'
        keywords={[
          ...keywordSets.localDealer,
          'harga BYD M6 DM',
          'harga BYD M6 DM BSD',
          'harga BYD M6 DM BSD Serpong',
          'BYD M6 DM coming soon',
          'pre book BYD M6 DM',
          'waiting list BYD M6 DM',
          'BYD M6 DM Tangerang Selatan',
          'BYD M6 DM Gading Serpong',
          'BYD M6 hybrid harga',
          'interior BYD M6 DM',
          'kabin BYD M6 DM',
        ]}
        path='/blog/harga-byd-m6-dm-bsd-serpong'
        image={heroM6Dm}
        type='article'
        jsonLd={[
          localBusinessJsonLd(),
          articleJsonLd({
            title: 'Harga BYD M6 DM BSD Serpong | Coming Soon & Pre-Book 2026',
            description:
              'Halaman update harga BYD M6 DM untuk BSD Serpong dan Tangerang Selatan, lengkap dengan status coming soon, info pre-book, spesifikasi awal, dan FAQ.',
            image: heroM6Dm,
            path: '/blog/harga-byd-m6-dm-bsd-serpong',
            datePublished: '2026-05-18',
            dateModified: '2026-05-18',
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'Blog', path: '/blog' },
            {
              name: 'Harga BYD M6 DM BSD Serpong',
              path: '/blog/harga-byd-m6-dm-bsd-serpong',
            },
          ]),
          faqJsonLd,
        ]}
      />

      <Box component='main' sx={{ backgroundColor: '#f4f7fb', overflow: 'hidden' }}>
        <HeroSection />
        <PriceIntentSection />
        <SpecSection />
        <InteriorSection />
        <AreaSection />
        <FaqSection />
        <CtaSection />
      </Box>
    </>
  );
}

function HeroSection() {
  return (
    <Box
      component='section'
      aria-labelledby='harga-m6dm-title'
      sx={{
        position: 'relative',
        minHeight: { xs: '88vh', md: '94vh' },
        display: 'flex',
        alignItems: 'flex-end',
        pt: { xs: 10, md: 11 },
        backgroundColor: '#0f172a',
      }}
    >
      <Box
        component='img'
        src={heroM6Dm}
        alt='Harga BYD M6 DM BSD Serpong coming soon'
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(2,6,23,0.26) 0%, rgba(2,6,23,0.14) 38%, rgba(2,6,23,0.86) 100%)',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 1180,
          mx: 'auto',
          px: { xs: 2, md: 5 },
          pb: { xs: 5, md: 7 },
          color: '#fff',
        }}
      >
        <Typography sx={eyebrowDark}>Harga BYD M6 DM</Typography>
        <Typography id='harga-m6dm-title' component='h1' sx={heroTitle}>
          Harga BYD M6 DM masih coming soon, pre-book bisa mulai dikonsultasikan
        </Typography>
        <Typography sx={heroText}>
          Halaman ini dibuat untuk calon pembeli di BSD Serpong, Tangerang
          Selatan, dan area sekitar yang ingin update harga BYD M6 DM, status
          unit, dan langkah pre-book lebih awal.
        </Typography>
        <Box
          sx={{
            mt: 2.5,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
            gap: 1,
            maxWidth: 880,
          }}
        >
          {specCards.map((item) => (
            <Box key={item.label} sx={darkStatCard}>
              <Typography sx={{ fontWeight: 900, fontSize: '1.05rem' }}>
                {item.value}
              </Typography>
              <Typography sx={{ mt: 0.3, opacity: 0.78, fontSize: '0.78rem' }}>
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
        <Box sx={{ mt: 3, display: 'flex', gap: 1.4, flexWrap: 'wrap' }}>
          <Button href={waLink} target='_blank' rel='noopener noreferrer' variant='contained' sx={buttonPrimary}>
            Tanya Harga M6 DM
          </Button>
          <Button component={RouterLink} to='/jelajahi-m6-dm' variant='outlined' sx={buttonGhost}>
            Lihat detail model
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

function PriceIntentSection() {
  return (
    <Box component='article' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}>
      <Box sx={{ maxWidth: 980, mx: 'auto' }}>
        <Typography sx={eyebrow}>Update Harga dan Pre-Book</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Yang perlu dilakukan sebelum harga BYD M6 DM diumumkan
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5 }}>
          Saat harga resmi belum diumumkan, pembeli biasanya butuh tiga hal:
          gambaran spesifikasi, estimasi kapan bisa dapat update unit, dan jalur
          komunikasi yang jelas. Karena itu, fokus halaman ini bukan menebak
          harga, tetapi membantu Anda masuk alur informasi yang benar dari BYD
          BSD Serpong.
        </Typography>

        <Box sx={{ mt: 3, display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
          {buyingPoints.map((item) => (
            <Box key={item.title} sx={infoCard}>
              <Typography component='h3' sx={{ fontSize: '1.18rem', fontWeight: 900 }}>
                {item.title}
              </Typography>
              <Typography sx={{ ...bodyText, mt: 1, fontSize: '0.96rem' }}>
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function SpecSection() {
  return (
    <Box component='section' aria-labelledby='spec-harga-m6dm-title' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}>
      <Box
        sx={{
          maxWidth: 1180,
          mx: 'auto',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
          gap: { xs: 3, md: 4 },
          alignItems: 'stretch',
        }}
      >
        <Box sx={imageCard}>
          <Box
            component='img'
            src={technologyM6Dm}
            alt='Teknologi Dual Mode BYD M6 DM'
            sx={{ width: '100%', height: { xs: 280, md: 420 }, objectFit: 'cover', display: 'block' }}
          />
        </Box>
        <Box sx={{ ...infoCard, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography sx={eyebrow}>Spesifikasi yang Banyak Dicari</Typography>
          <Typography id='spec-harga-m6dm-title' component='h2' sx={sectionTitle}>
            M6 DM mengisi celah antara MPV EV dan mobil keluarga bensin
          </Typography>
          <Typography sx={{ ...bodyText, mt: 1.5 }}>
            BYD M6 DM membawa kombinasi baterai 18 kWh, tangki bensin 52 liter,
            akselerasi 0-100 km/h 10.1 detik, dan range hingga 1200 km NEDC.
            Intinya, mobil ini ditujukan untuk keluarga yang ingin rasa
            berkendara listrik tanpa meninggalkan fleksibilitas perjalanan jauh.
          </Typography>
          <Typography sx={{ ...bodyText, mt: 1.2 }}>
            Materi teknologi DM juga menekankan karakter gesit, andal, senyap,
            dan irit. Untuk pemakaian di Indonesia, poin paling praktis adalah
            biaya harian bisa ditekan, sementara rute luar kota tetap lebih
            tenang karena ada dukungan bensin.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

function InteriorSection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}>
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Contoh Interior</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Interior BYD M6 DM juga jadi pertimbangan sebelum pre-book
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5, maxWidth: 840 }}>
          Selain harga yang masih coming soon, calon pembeli biasanya perlu
          melihat suasana kabin. Foto berikut memberi gambaran speedometer
          digital, kursi penumpang, susunan tiga baris kursi, dashboard, dan
          setir BYD M6 DM.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {interiorCards.map((item) => (
            <Box key={item.title} sx={imageCard}>
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                loading='lazy'
                sx={{
                  width: '100%',
                  height: { xs: 230, md: 260 },
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <Box sx={{ p: 2.4 }}>
                <Typography component='h3' sx={{ fontSize: '1.18rem', fontWeight: 900 }}>
                  {item.title}
                </Typography>
                <Typography sx={{ ...bodyText, mt: 0.8, fontSize: '0.96rem' }}>
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function AreaSection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}>
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Area Layanan</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Update harga BYD M6 DM untuk BSD dan area sekitar
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5, maxWidth: 860 }}>
          BYD BSD Serpong relevan untuk calon pembeli dari area berikut yang
          mencari harga BYD M6 DM, pre-book, simulasi pembelian, dan jadwal
          test drive saat unit tersedia.
        </Typography>
        <Box sx={{ mt: 3, display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(3, 1fr)' }, gap: 1.5 }}>
          {areaCards.map((area) => (
            <Box key={area} sx={areaChip}>
              {area}
            </Box>
          ))}
        </Box>
        <Box sx={{ ...imageCard, mt: 3 }}>
          <Box
            component='img'
            src={showroomM6Dm}
            alt='BYD M6 DM di showroom BYD BSD Serpong'
            sx={{ width: '100%', height: { xs: 280, md: 460 }, objectFit: 'cover', display: 'block' }}
          />
        </Box>
      </Box>
    </Box>
  );
}

function FaqSection() {
  return (
    <Box component='section' aria-labelledby='faq-harga-m6dm-title' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}>
      <Box sx={{ maxWidth: 920, mx: 'auto' }}>
        <Typography id='faq-harga-m6dm-title' component='h2' sx={sectionTitle}>
          FAQ harga BYD M6 DM
        </Typography>
        <Box sx={{ mt: 2.5, display: 'grid', gap: 1.3 }}>
          {faqItems.map((item) => (
            <Box
              key={item.question}
              component='details'
              sx={{
                p: 2,
                borderRadius: '8px',
                backgroundColor: '#fff',
                border: '1px solid rgba(17,24,39,0.08)',
                '& summary': {
                  cursor: 'pointer',
                  fontWeight: 900,
                  color: '#111827',
                },
              }}
            >
              <Box component='summary'>{item.question}</Box>
              <Typography sx={{ mt: 1.2, color: '#4b5563', lineHeight: 1.75 }}>
                {item.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function CtaSection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, pb: { xs: 7, md: 9 } }}>
      <Box
        sx={{
          maxWidth: 1080,
          mx: 'auto',
          borderRadius: '8px',
          backgroundColor: '#111827',
          color: '#fff',
          px: { xs: 2.5, md: 4 },
          py: { xs: 3.5, md: 4.5 },
          textAlign: 'center',
        }}
      >
        <Typography component='h2' sx={sectionTitleDark}>
          Mau dikabari saat harga BYD M6 DM keluar?
        </Typography>
        <Typography sx={{ mt: 1.5, maxWidth: 760, mx: 'auto', color: 'rgba(255,255,255,0.78)', lineHeight: 1.8 }}>
          Kirim pesan ke Junius untuk update harga coming soon, pre-book,
          ketersediaan unit, dan jadwal test drive BYD M6 DM di BYD BSD
          Serpong.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Button href={waLink} target='_blank' rel='noopener noreferrer' variant='contained' sx={buttonPrimary}>
            Chat WhatsApp Junius
          </Button>
          <Button component={RouterLink} to='/pricing' variant='outlined' sx={buttonGhost}>
            Lihat pricing BYD
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const eyebrow = {
  color: '#4c5867',
  fontWeight: 800,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  fontSize: '0.82rem',
};

const eyebrowDark = {
  display: 'inline-flex',
  px: 1.2,
  py: 0.65,
  borderRadius: '999px',
  backgroundColor: 'rgba(255,255,255,0.12)',
  border: '1px solid rgba(255,255,255,0.2)',
  fontSize: '0.78rem',
  fontWeight: 900,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
};

const heroTitle = {
  mt: 1.6,
  fontSize: { xs: '2.25rem', sm: '3.2rem', md: '4.7rem' },
  fontWeight: 900,
  lineHeight: 0.98,
  maxWidth: 930,
};

const heroText = {
  mt: 1.5,
  maxWidth: 760,
  fontSize: { xs: '1rem', md: '1.08rem' },
  lineHeight: 1.8,
  color: 'rgba(255,255,255,0.9)',
};

const sectionTitle = {
  mt: 1,
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  color: '#111827',
  lineHeight: 1.05,
};

const sectionTitleDark = {
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  lineHeight: 1.05,
};

const bodyText = {
  color: '#4b5563',
  lineHeight: 1.8,
  fontSize: { xs: '1rem', md: '1.05rem' },
};

const infoCard = {
  p: 2.4,
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.06)',
};

const imageCard = {
  overflow: 'hidden',
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
};

const darkStatCard = {
  border: '1px solid rgba(255,255,255,0.22)',
  backgroundColor: 'rgba(0,0,0,0.38)',
  borderRadius: '8px',
  px: 1.5,
  py: 1.25,
};

const areaChip = {
  p: 1.7,
  borderRadius: '8px',
  backgroundColor: '#f8fafc',
  border: '1px solid rgba(17,24,39,0.08)',
  color: '#111827',
  fontWeight: 900,
  textAlign: 'center',
};

const buttonPrimary = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  backgroundColor: '#1f5fd1',
  '&:hover': { backgroundColor: '#184ca8' },
};

const buttonGhost = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  color: '#fff',
  borderColor: 'rgba(255,255,255,0.68)',
  '&:hover': {
    borderColor: '#fff',
    backgroundColor: 'rgba(255,255,255,0.1)',
  },
};

export default HargaM6DMDetail;
